function TrustBar({ logos = [] }) {
  return (
    <section className="trust-bar" aria-label="Association partners">
      <div className="container trust-bar-inner">
        <p className="trust-copy">
          Trusted by 300+ schools and state education organizations nationwide
        </p>

        <div className="trust-logos">
          {logos.map((logoItem) => {
            const key = logoItem.id || logoItem.slug || logoItem.name;
            const content = <img src={logoItem.logo} alt={logoItem.name} />;

            if (logoItem.website) {
              return (
                <a
                  key={key}
                  href={logoItem.website}
                  target="_blank"
                  rel="noreferrer"
                  className="trust-logo-item"
                  aria-label={logoItem.name}
                >
                  {content}
                </a>
              );
            }

            return (
              <span key={key} className="trust-logo-item" aria-label={logoItem.name}>
                {content}
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default TrustBar;
